import { useEffect, useState } from "react";
import {
  Stack, Text,
  Box,
  Flex,
  Tooltip,
  Link,
  IconButton,
  ListIcon,
  Icon,
  Button,
} from "@chakra-ui/react";

import { FiMessageSquare } from "react-icons/fi";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import { useSession } from "next-auth/client";
import { format, formatDistance } from "date-fns";
import { ImCross } from "react-icons/im";
import { firebaseClient } from "firebaseClient";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { getAccount, updateUser, getAuthUrl, selectAccount } from "utils/sessionHelper";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdCheckCircle } from 'react-icons/md';
import { BiErrorAlt, BiDotsHorizontalRounded } from 'react-icons/bi';


function HistoryItem({ item, index, session }) {
  console.log('item:', item)

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Flex key={index} rounded="lg" justifyContent="space-between" alignItems="center" w="100%" bg="gray.50" p={3}>
      <Link isExternal href={"https://twitter.com/" + item.twUserName}><Text w="150px" noOfLines={1} wordBreak="break-all" >@{item.twUserName}</Text></Link>
      <Link mx={2} isExternal href={"https://twitter.com/messages/" + getAccount(session)?.id + "-" + item.to} rel="noreferrer"><FiMessageSquare /></Link>
      <CopyToClipboard
        text={item.text}
        onCopy={() => {
          toast.success("DM copied to clipboard");
        }}
      >
        <Text w="300px" noOfLines={1} wordBreak="break-all">{item.text}</Text>
      </CopyToClipboard>
      {
        item.status === "error" ? (
          <Tooltip label={item.message}>
            <Flex alignItems="center">
              <Icon mr={2} as={BiErrorAlt} color="red.400" fontSize="20px" />
              <Text w="100px" fontWeight="600">{item.status}</Text>
            </Flex>
          </Tooltip>
        ) : (
          <Flex>
            {
              item.status === "sent" ? (
                <Icon mr={2} as={MdCheckCircle} color="green.400" fontSize="20px" />
              ) : (
                <Icon mr={2} as={BiDotsHorizontalRounded} color="gray.400" fontSize="20px" />
              )
            }
            <Text w="100px" fontWeight="600">{item.status}</Text>
          </Flex>
        )
      }
      <Text w="150px">{formatDistance(item.from.toDate(), new Date(), { addSuffix: true })}</Text>
      <IconButton
        size="sm"
        aria-label="cancel DM"
        icon={<ImCross fontSize="8px" />}
        isLoading={isLoading}
        isDisabled={item.status != "queue"}
        onClick={async (e) => {
          console.log("cancel DM");
          setIsLoading(true);
          const db = firebaseClient.firestore();
          await db.collection("users").doc(getAccount(session).id).collection("accounts").doc(getAccount(session).idAccount).collection("dms").doc(item.id).update({ status: "canceled" });
          item.status = "canceled";
          setIsLoading(false);
        }}
      />
    </Flex>
  )
}

export function History({ history, mt = 20, disableHeader = false, refresher = ({ }) => { } }) {

  const router = useRouter();
  const [session, loading] = useSession();
  const isAuthenticated = useFirebaseUser();
  const [isDMsPaused, setIsDMsPaused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      setIsDMsPaused(getAccount(session)?.isDMsPaused);
    }
  }, [isAuthenticated]);

  return (
    <Box w="100%" mt={mt} overflow="auto">
      {
        !disableHeader &&
        <Flex justifyContent="space-between">
          <Text fontWeight="600" fontSize="lg">DM History</Text>
          <Flex alignItems="center">
            {
              isDMsPaused &&
              <Text mr={4} color="red.500" fontSize="sm" fontWeight="600">DMs are paused</Text>
            }
            <Button
              onClick={async () => {
                setIsDMsPaused(!isDMsPaused);
                await updateUser(session, { isDMsPaused: !getAccount(session)?.isDMsPaused });
              }}
              size="sm"
              variant="outline"
              colorScheme={isDMsPaused ? "green" : "red"}
            >
              {isDMsPaused ? "Resume DMs" : "Pause DMs"}
            </Button>
            <Button
              onClick={async () => {
                setIsLoading(true);
                const db = firebaseClient.firestore();
                let docs = await db.collection("users").doc(getAccount(session).id).collection("accounts").doc(getAccount(session).idAccount).collection("dms").get();
                for await (const doc of docs.docs) {
                  await doc.ref.delete();
                }
                setIsLoading(false);
                refresher && refresher({});
              }}
              size="sm"
              ml={4}
              colorScheme="red"
              isLoading={isLoading}
            >
              Clear DMs
            </Button>
          </Flex>
        </Flex>
      }
      <Stack
        spacing="4"
        fontSize="sm"
        w="100%"
        mt={5}
        minW="800px"
      >
        {
          history.map((h, index) => (
            <HistoryItem key={index + "-item"} index={index} item={h} session={session} />
          ))
        }
      </Stack>
    </Box>
  );
}
